<template>
    <LayoutBase :has-fixed-group="hasFixedGroup" :nav="nav">
        <div id="inner-wrapper" class="container-full" :class="{ 'small': small }">
            <slot name="breadcrumbs"></slot>
            <slot name="header"></slot>
            <slot></slot>
        </div>
    </LayoutBase>
</template>

<script>
import LayoutBase from './LayoutBase';

export default {
    name: "LayoutWithContainer",
    components: {
        LayoutBase
    },
    props: {
        nav: {
            type: Boolean,
            default: true,
        },
        hasFixedGroup: {
            type: Boolean,
            default: false,
        },
        small: {
            type: Boolean,
            default: false,
        },
    }
}
</script>

<style lang="scss" scoped>
#inner-wrapper {
    padding-left: 0;
    padding-right: 0;
}
</style>

<style lang="scss">
#content {
    .grid.grid--cards {
        margin-top: -1.5rem;
        margin-bottom: -1.5rem;
    }
}
</style>
